var _defs, _rect, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCreateInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b,.c{stroke:#000;stroke-linecap:round;stroke-width:0.75px;}.b{stroke-linejoin:round;}.c{fill:#fff;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.605,3H5A.945.945,0,0,0,4,4v8a.945.945,0,0,0,1,1h6a.945.945,0,0,0,1-1V7.664"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 0.2)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 5,
    transform: "translate(8 4.942)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 5,
    transform: "translate(10.442 2.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateInvoice);
export default __webpack_public_path__ + "static/media/Icon_Create_Invoice.de8d1964ef633c21719b1a0fda503e72.svg";
export { ForwardRef as ReactComponent };